import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

function sortOrder (options) {
  return function (a, b) {
    var optionA = options[a];
    var optionB = options[b];
    if (_typeof(optionA) === 'object' && _typeof(optionB) === 'object') {
      if ('sortOrder' in optionA && 'sortOrder' in optionB) {
        var _optionA$sortOrder, _optionB$sortOrder;
        var valueA = (_optionA$sortOrder = optionA.sortOrder) !== null && _optionA$sortOrder !== void 0 ? _optionA$sortOrder : 0;
        var valueB = (_optionB$sortOrder = optionB.sortOrder) !== null && _optionB$sortOrder !== void 0 ? _optionB$sortOrder : 0;
        if (valueA < valueB) {
          return -1;
        }
        if (valueA > valueB) {
          return 1;
        }
      }
    }
    return 0;
  };
}

export default sortOrder;
//# sourceMappingURL=sort-order.esm.js.map
